export default {
  data () {
    return {
      columns: [
        {
          title: 'id',
          type: 'index'
        }, {
          title: '用户名',
          key: 'userName'
        }
      ]
    }
  },
  methods: {
    roleManage ({ row }, platCode) {
      this.$refs['roleTreeRef'].treeStatus = true
      let current = { ...row }
      current.platCode = platCode
      this.currentRole = current
    },
    resetColumns () {
      this.columns = [
        {
          title: 'id',
          type: 'index'
        }, {
          title: '用户名',
          key: 'userName'
        }
      ]
    }
  }
}
